import { createContext, useReducer, useMemo } from 'react'
import { ContextState, Action, BreadcrumbVariant } from './types'

const defaultState = {
  breadcrumbs: [],
  variant: BreadcrumbVariant.default,
}

export const PageHeaderContext = createContext<{
  state: ContextState
  dispatch: React.Dispatch<any>
}>({
  state: defaultState,
  dispatch: () => {
    // do nothing
  },
})

/**
 * Page Header provider reducer state machine.
 * @param {State} state
 * @param {Action} action
 * @returns {State}
 */
function reducer(state: ContextState, action: Action): ContextState {
  switch (action.type) {
    case 'setBreadcrumbs': {
      const breadcrumbs = action.payload

      return {
        ...state,
        breadcrumbs,
      }
    }
    case 'setPageHeader': {
      const { breadcrumbs, variant } = action.payload
      return {
        ...state,
        breadcrumbs,
        variant,
      }
    }
    default:
      return state
  }
}

export const PageHeaderProvider = ({ children, initialState = {} }) => {
  const [state, dispatch] = useReducer(reducer, { ...defaultState, ...initialState })
  const value = useMemo(() => ({ state, dispatch }), [state, dispatch])

  return <PageHeaderContext.Provider value={value}>{children}</PageHeaderContext.Provider>
}
